module.exports = "<select class=\"w3-select w3-block w3-border w3-round\"\r\n  [(ngModel)]=\"value\"\r\n  [disabled]=\"isDisabled\">\r\n  <option [value]=\"null\">Select type</option>\r\n  <option *ngFor=\"let t of types\" [value]=\"t\">{{t}}</option>\r\n</select>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/shared/ztsi-expense-type-picker/ztsi-expense-type-picker.component.html
// module id = ./src/app/components/shared/ztsi-expense-type-picker/ztsi-expense-type-picker.component.html
// module chunks = main